var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.groups.filter(function (g) { return g.value !== 'studentId' || _vm.perm !== 'student'; }),"label":"Group By","dense":""},model:{value:(_vm.gVal),callback:function ($$v) {_vm.gVal=$$v},expression:"gVal"}})}
var staticRenderFns = []

export { render, staticRenderFns }